import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from '../../../../libraries/language';
import { TailNumberFormSchema } from '../../../../models/tail-number.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const TailNumbersForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={TailNumberFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="2">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_TAIL_NUMBER}
                    name="tailNumber"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    clearable
                    required
                    error={errors.tailNumber}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="tailId"
                    control={control}
                    error={errors.tailId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default TailNumbersForm;
